import React from 'react';
interface HeroSectionProps {
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}
export function HeroSection(_props: HeroSectionProps) {
  return <section className="w-full overflow-hidden bg-[#0B0B0B]" aria-label="NOIZA" data-id="element-2440" data-mp="34rdvjywuehj2">
      <img src="https://cdn.magicpatterns.com/uploads/kAKeYiH7MNMwKxW94fw24o/DABF548B-EAE7-4550-9CBF-4AB1434EFF8B.png" alt="NOIZA — La libertad ilumina nuestro camino. 15 de septiembre, Costa Rica" className="block h-auto w-full max-h-[78vh] object-cover object-center" data-id="element-2441" data-mp="2qtp7ki7hau9s" />
    </section>;
}